import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Label } from '../ui/label';
import { Slider } from '../ui/slider';

const SURVEY_LABELS = {
  control: 'Sense of Control',
  productivity: 'Productivity',
  efficiency: 'Efficiency',
  contentment: 'Contentment',
  self_esteem: 'Self Esteem',
  concentration: 'Concentration',
  work_life_balance: 'Work-Life Balance'
};

export const WellbeingSurveyDialog = ({ open, onOpenChange, data, onChange, onSubmit }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-['Manrope']">Wellbeing Check</DialogTitle>
        </DialogHeader>
        <div className="py-4 space-y-6 max-h-[60vh] overflow-y-auto">
          <p className="text-sm text-muted-foreground">
            Please rate how you feel (0 = Very Low, 10 = Very High)
          </p>
          {Object.entries(SURVEY_LABELS).map(([key, label]) => (
            <div key={key} className="space-y-2">
              <div className="flex justify-between">
                <Label>{label}</Label>
                <span className="text-sm font-medium">{data[key]}</span>
              </div>
              <Slider
                value={[data[key]]}
                onValueChange={([value]) => onChange({ ...data, [key]: value })}
                max={10}
                step={1}
                className="w-full"
                data-testid={`dashboard-survey-slider-${key}`}
              />
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Later</Button>
          <Button onClick={onSubmit} data-testid="dashboard-submit-survey-btn">Submit</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
